const sgm_data = [
  {
    id: 1,
    date: "PMC Appointment",
    time: "--",
    pdf: "sgm/pmc_appointment.pdf",
  },

  {
    id: 2,
    date: "10 April 2022",
    time: "7pm",
    pdf: "sgm/sgm3.pdf",
  },
  {
    id: 3,
    date: "20 August 2023",
    time: "7pm",
    pdf: "sgm/sgm4.pdf",
  },
  {
    id: 4,
    date: "24 Septemeber 2023",
    time: "11 am",
    pdf: "sgm/sgm8.pdf",
  },
  {
    id: 5,
    date: "22 October 2023",
    time: "7pm",
    pdf: "sgm/sgm6.pdf",
  },
  {
    id: 6,
    date: "29 October 2023",
    time: "10:00 am",
    pdf: "sgm/sgm1.pdf",
  },

  {
    id: 7,
    date: "7 January 2024",
    time: "9:30 am",
    pdf: "sgm/sgm7.pdf",
  },
  {
    id: 8,
    date: "23 January 2024",
    time: "7pm",
    pdf: "sgm/sgm2.pdf",
  },
  {
    id: 9,
    date: "26 May 2024",
    time: "7pm",
    pdf: "sgm/sgm5.pdf",
  },
  {
    id: 10,
    date: "9 June 2024",
    time: "--",
    pdf: "sgm/sgm10.pdf",
  },
  {
    id: 11,
    date: "30 June 2024",
    time: "--",
    pdf: "sgm/sgm9.pdf",
  },

  {
    id: 12,
    date: "16 June 2024",
    time: "--",
    pdf: "sgm/sgm11.pdf",
  },
  {
    id: 13,
    date: "3 September 2024",
    time: "--",
    pdf: "sgm/sgm12.pdf",
  },
  {
    id: 14,
    date: "13 September 2024",
    time: "--",
    pdf: "sgm/sgm13.pdf",
  },
  {
    id: 15,
    date: "NEWSPAPER AD",
    time: "--",
    pdf: "sgm/NEWSPAPER_1_AD.pdf",
  },
  {
    id: 16,
    date: "NEWSPAPER AD",
    time: "--",
    pdf: "sgm/NEWSPAPER_2_AD.pdf",
  },
  {
    id: 17,
    date: "NEWSPAPER AD",
    time: "--",
    pdf: "sgm/NEWSPAPER_3_AD.pdf",
  },
  {
    id: 18,
    date: "PMC APPOINTMENT",
    time: "--",
    pdf: "sgm/PMC_APPOINTMENT2.pdf",
  },
  {
    id: 19,
    date: "APPOINTMENT LETTER TO METRO NOC",
    time: "--",
    pdf: "sgm/appoiintment_letter_to_metro_noc.pdf",
  },
  {
    id: 20,
    date: "COLLECTOR LETTER",
    time: "--",
    pdf: "sgm/collector_letter.pdf",
  },
  {
    id: 21,
    date: "LETTER TO METRO",
    time: "--",
    pdf: "sgm/letter_to_metro.pdf",
  },
  {
    id: 22,
    date: "PAYMENT RECEIPT FREE HOLD",
    time: "--",
    pdf: "sgm/payment_receipt_free_hold.pdf",
  },
  {
    id: 23,
    date: "PLOTVIBHAJAN",
    time: "--",
    pdf: "sgm/POTVIBHAJAN.pdf",
  },
  {
    id: 24,
    date: "RAJESH INDEMNITY BOND",
    time: "--",
    pdf: "sgm/RAJESH_INDEMNITY_BOND.pdf",
  },

  {
    id: 25,
    date: "ALL ANNEXURES",
    time: "--",
    pdf: "sgm/ALL ANNEXURES.pdf",
  },
  {
    id: 26,
    date: "REVISED DA",
    time: "--",
    pdf: "sgm/REVISED DA.pdf",
  },
  {
    id: 27,
    date: "AGENDA FOR SGM ON 15TH JUNE 2025",
    time: "--",
    pdf: "sgm/AGENDA FOR SGM ON 15TH JUNE 2025.pdf",
  },
  {
    id: 28,
    date: "DRAFT CONSENT FOR EXTRA PARKING",
    time: "--",
    pdf: "sgm/DRAFT CONSENT FOR EXTRA PARKING.pdf",
  },
  {
    id: 29,
    date: "MINUTES OF SGM ON 15TH JUNE 2025",
    time: "--",
    pdf: "sgm/MINUTES OF SGM ON 15TH JUNE 2025.pdf",
  },
  {
    id: 30,
    date: "MINUTES OF SGM ON 13TH JULY 2025",
    time: "--",
    pdf: "sgm/MINUTES OF SGM ON 13TH JULY 2025.pdf",
  },

  {
    id: 31,
    date: "STRUCTURAL AUDIT REPORT",
    time: "--",
    pdf: "sgm/STRUCTURAL AUDIT REPORT.pdf",
  },
  {
    id: 32,
    date: "AGENDA FOR SGM ON 21ST SEPT 2025",
    time: "--",
    pdf: "sgm/AGENDA FOR SGM ON 21ST SEPT 2025.pdf",
  },
  {
    id: 33,
    title: "AH - CFO NOC.pdf",
    date: "AH - CFO NOC.pdf",
    time: "--",
    pdf: "sgm/October2026/AH - CFO NOC.pdf",
  },
  {
    id: 34,
    title: "AH - Collector Sub Division.pdf",
    date: "AH - Collector Sub Division.pdf",
    time: "--",
    pdf: "sgm/October2026/AH - Collector Sub Division.pdf",
  },
  {
    id: 35,
    title: "AH - Demarcation of Road Setback.pdf",
    date: "AH - Demarcation of Road Setback.pdf",
    time: "--",
    pdf: "sgm/October2026/AH - Demarcation of Road Setback.pdf",
  },
  {
    id: 36,
    title: "AH - MMRDA Metro NOC.pdf",
    date: "AH - MMRDA Metro NOC.pdf",
    time: "--",
    pdf: "sgm/October2026/AH - MMRDA Metro NOC.pdf",
  },
  {
    id: 37,
    title: "AH - Parking Remarks.pdf",
    date: "AH - Parking Remarks.pdf",
    time: "--",
    pdf: "sgm/October2026/AH - Parking Remarks.pdf",
  },
  {
    id: 38,
    title: "AH - PRC.pdf",
    date: "AH - PRC.pdf",
    time: "--",
    pdf: "sgm/October2026/AH - PRC.pdf",
  },
  {
    id: 39,
    title: "AH - SWM NOC.pdf",
    date: "AH - SWM NOC.pdf",
    time: "--",
    pdf: "sgm/October2026/AH - SWM NOC.pdf",
  },
  {
    id: 40,
    title: "AH - TREE NOC.pdf",
    date: "AH - TREE NOC.pdf",
    time: "--",
    pdf: "sgm/October2026/AH - TREE NOC.pdf",
  },
  {
    id: 41,
    title: "AH Civil Aviation NOC Mumbai.pdf",
    date: "AH Civil Aviation NOC Mumbai.pdf",
    time: "--",
    pdf: "sgm/October2026/AH Civil Aviation NOC Mumbai.pdf",
  },
  {
    id: 42,
    title: "AH Status of Road from A.E..pdf",
    date: "AH Status of Road from A.E..pdf",
    time: "--",
    pdf: "sgm/October2026/AH Status of Road from A.E..pdf",
  },
  {
    id: 43,
    title: "Minutes_to_general_body_meeting.pdf",
    date: "Minutes_to_general_body_meeting.pdf",
    time: "--",
    pdf: "sgm/October2026/Minutes_to_general_body_meeting.pdf",
  },
  {
    id: 44,
    title: "Minutes_to_general_body_meeting_19_july.pdf",
    date: "Minutes_to_general_body_meeting_19_july.pdf",
    time: "--",
    pdf: "sgm/October2026/Minutes_to_general_body_meeting_19_july.pdf",
  },
  {
    id: 45,
    title: "Vardhanab_infra_construction_limited.pdf",
    date: "Vardhanab_infra_construction_limited.pdf",
    time: "--",
    pdf: "sgm/October2026/Vardhanab_infra_construction_limited.pdf",
  },
];

export default sgm_data;
